import toastr from 'toastr';
import { isEmpty as isEmptyObject } from 'lodash';

export function maskSecret(str, length = 5) {
  return `${str.substring(0, length)}...${str.substring(str.length - length)}`;
}

export function displayApiValidationErrors(errors) {
  let objectProps = Object.keys(errors);
  if (objectProps.length > 0) {
    objectProps.map((prop) => {
      toastr.warning(errors[prop][0]);
    });
  }
}

export function shuffle8() {
  var shuffle = (a, b) => (Math.random() > 0.5 ? -1 : 1),
    lowercase = 'abcdefghijklmnopqrstuvwxyz'.split('').sort(shuffle).join('').substring(0, 4),
    uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').sort(shuffle).join('').substring(0, 2),
    numeric = '0123456789'.split('').sort(shuffle).join('').substring(0, 2);

  return (lowercase + uppercase + numeric).split('').sort(shuffle).join('');
}

export function findPos(obj) {
  var curtop = 0;
  if (obj.offsetParent) {
    do {
      curtop += obj.offsetTop;
    } while ((obj = obj.offsetParent));
    return [curtop];
  }
}

export function paramsAreDifferent(a, b) {
  return JSON.stringify(a ?? {}) !== JSON.stringify(b ?? {});
}

export function setParamOnUrl(param, value) {
  var url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  if (params.has(param)) {
    params.set(param, value);
  } else {
    params.append(param, value);
  }
  window.history.replaceState({}, '', `${location.pathname}?${params}`);
}

export const updateObjectsInArray = (items, itemId, objPropName, newObjProps) => {
  return items.map((u) => {
    if (u[objPropName] === itemId) {
      return {
        ...u,
        ...newObjProps,
      };
    }
    return u;
  });
};

/**
 * Determines whether a value should be considered "empty".
 *
 * Behavior by type:
 * - string: returns true if the string is empty or contains only whitespace
 *   characters (i.e. value.trim().length === 0); otherwise false.
 * - number: always returns false; numeric values (including 0 and NaN) are
 *   never treated as empty.
 * - object / array: delegates to lodash's isEmpty:
 *   - arrays: true if the array has length 0; otherwise false.
 *   - plain objects / other collection-like values: true if they have no own
 *     enumerable properties/elements; otherwise false.
 * - null / undefined: considered empty (lodash's isEmpty returns true).
 * - other types (e.g. boolean, function, Date): follow lodash's isEmpty
 *   semantics (typically true when they have no own enumerable properties).
 *
 * @param {*} value Value to check for emptiness.
 * @returns {boolean} True if the value is considered empty; otherwise false.
 */
export function isEmpty(value) {
  if (typeof value === 'string') {
    return value.trim().length === 0;
  }

  if (typeof value === 'number') {
    return false;
  }

  return isEmptyObject(value);
}
